<template>
  <table
    class="table table-sm-responsive table-bordered border-0"
    id="channelReportsTable"
  >
    <caption class="d-none"></caption>
    <thead>
      <tr>
        <th scope="col">Channel</th>
        <th scope="col">Channel Name</th>
        <th scope="col">Amount</th>
        <th scope="col">Details</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(data, index) in tableData" :key="index">
        <td>{{ data.channel }}</td>
        <td>{{ data.channel_name }}</td>
        <td>{{ new Intl.NumberFormat("en-GB").format(data.amount) }}</td>
        <td>
          <button
            :disabled="isDownloading"
            class="btn btn--primary btn-block"
            @click="downloadChannel(data.channel)"
          >
            Download
          </button>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
import moment from 'moment'
export default {
  props: {
    tableData: {
      default: () => [],
      required: false,
    },
  },

  data() {
    return {
      isDownloading: false,
    };
  },

  methods: {
    async downloadChannel(channel) {
      this.isDownloading = true;
      try {
        const firstDay = new Date(
          new Date().getFullYear(),
          new Date().getMonth(),
          1
        );
        // const res = await this.$repos.reports.downloadReportChannel({
        //   channel: channel.toUpperCase(),
        //   startDate: moment(firstDay).format("YYYY-MM-DD"),
        //   endDate: moment().format("YYYY-MM-DD"),
        // });
        // const binaryData = [];
        // binaryData.push(res);
        // const objectUrl = window.URL.createObjectURL(
        //   new Blob(binaryData, { type: "application/vnd.ms-excel" })
        // );


        const startDate = moment(firstDay).format("YYYY-MM-DD")
        const endDate = moment().format("YYYY-MM-DD")
        const url = 'https://payment.eirs.gov.ng/api/reports/channel-base-collections/download?channel='+channel.toUpperCase()+'&start_date='+startDate+'&end_date='+endDate
        const link = document.createElement("a");
        // link.setAttribute("download", channel + '.xls');
        link.href = url;
        link.click();

        // window.open(url, '_blank')
      } catch (error) {
        console.log("error", error);
        this.showErrorNotification("Error downloading channel");
      } finally {
        this.isDownloading = false;
      }
    },
  },
};
</script>
